/**
 * edd-consent.js (v2)
 * ===================
 *
 * Bookstore12 - 카트 페이지 EDD (Estimated Delivery Date) 동의 처리.
 *
 * v2: display_pretty 필드 사용 ("Jun 1 - Jun 5, 2026" 형식)
 */

(function () {
  'use strict';

  var API_URL = 'https://admin.bookstore12.com/api/edd/preview';

  var box = document.getElementById('edd-consent-box');
  if (!box) {
    return;
  }

  var checkbox = document.getElementById('edd-consent-checkbox');
  var standardDateEl = document.getElementById('edd-standard-date');
  var expressDateEl = document.getElementById('edd-express-date');
  var loadingEl = document.getElementById('edd-loading');
  var errorEl = document.getElementById('edd-error');
  var cartForm = document.getElementById('cart');
  var checkoutBtn = cartForm ? cartForm.querySelector('button[name="checkout"]') : null;
  var expressWrapper = document.querySelector('.additional-checkout-buttons');

  var eddData = null;

  function fetchEDD() {
    if (loadingEl) loadingEl.style.display = '';
    if (errorEl) errorEl.style.display = 'none';

    fetch(API_URL)
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        eddData = data;
        renderEDD(data);
        if (loadingEl) loadingEl.style.display = 'none';
      })
      .catch(function (err) {
        console.error('[EDD] fetch failed:', err);
        if (loadingEl) loadingEl.style.display = 'none';
        if (errorEl) {
          errorEl.style.display = '';
          errorEl.textContent = '예상 배송일을 불러올 수 없습니다. 페이지를 새로고침해주세요.';
        }
      });
  }

  function renderEDD(data) {
    if (standardDateEl && data.standard) {
      standardDateEl.textContent = data.standard.display_pretty || data.standard.display;
    }
    if (expressDateEl && data.express) {
      expressDateEl.textContent = data.express.display_pretty || data.express.display;
    }
  }

  function applyCheckboxState() {
    var checked = checkbox && checkbox.checked;

    if (checkoutBtn) {
      if (checked) {
        checkoutBtn.removeAttribute('disabled');
        checkoutBtn.style.opacity = '';
        checkoutBtn.style.cursor = '';
      } else {
        checkoutBtn.setAttribute('disabled', 'disabled');
        checkoutBtn.style.opacity = '0.5';
        checkoutBtn.style.cursor = 'not-allowed';
      }
    }

    if (expressWrapper) {
      expressWrapper.style.display = checked ? '' : 'none';
    }
  }

  function recordConsent() {
    if (!eddData) {
      console.warn('[EDD] eddData not yet loaded, skipping attribute record');
      return;
    }

    var attributes = {
      'EDD_Confirmed_At': new Date().toISOString(),
      'EDD_Standard': eddData.standard.display_pretty || eddData.standard.display,
      'EDD_Express': eddData.express.display_pretty || eddData.express.display,
      'EDD_Order_Date': eddData.order_date
    };

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function () {
        console.log('[EDD] consent recorded:', attributes);
      })
      .catch(function (err) {
        console.error('[EDD] failed to record consent:', err);
      });
  }

  function handleCheckboxChange() {
    applyCheckboxState();
    if (checkbox && checkbox.checked) {
      recordConsent();
    }
  }

  function handleFormSubmit(e) {
    if (e.submitter && e.submitter.name !== 'checkout') {
      return;
    }

    if (!checkbox || !checkbox.checked) {
      e.preventDefault();
      e.stopPropagation();

      box.style.outline = '2px solid #DB4040';
      box.style.outlineOffset = '4px';
      setTimeout(function () {
        box.style.outline = '';
        box.style.outlineOffset = '';
      }, 2000);

      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      alert('예상 배송일 확인 체크박스에 체크해주세요.');
      return false;
    }
  }

  function init() {
    fetchEDD();
    applyCheckboxState();

    if (checkbox) {
      checkbox.addEventListener('change', handleCheckboxChange);
    }

    if (cartForm) {
      cartForm.addEventListener('submit', handleFormSubmit, true);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();